import { apiFetch } from '../../config/api';

/**
 * Feature Service
 * Handles feature-related API operations
 */
export const featureService = {
  /**
   * Load tenant features
   */
  async loadTenantFeatures() {
    const response = await apiFetch(`/api/v1/tenant/features`);
    return response.features || [];
  },

  /**
   * Load all available features
   */
  async loadFeatures() {
    const response = await apiFetch('/api/v1/tenant/features');
    return response || [];
  },

  /**
   * Update tenant features
   */
  async updateTenantFeatures(features) {
    const response = await apiFetch(`/api/v1/tenant/features`, {
      method: 'PUT',
      body: JSON.stringify(features),
    });
    return response.data;
  },

  /**
   * Check if feature is enabled for tenant (case-insensitive)
   */
  isFeatureEnabled(tenantFeatures, featureCode) {
    if (!tenantFeatures.length || !featureCode) return false;

    const normalizedCode = featureCode.toUpperCase();
    const tenantFeature = tenantFeatures.find(
      tf =>
        tf.feature_code &&
        tf.feature_code.toUpperCase() === normalizedCode &&
        tf.is_enabled
    );
    return !!tenantFeature;
  },

  /**
   * Get feature configuration for tenant (case-insensitive)
   */
  getFeatureConfig(tenantFeatures, featureCode) {
    if (!tenantFeatures.length || !featureCode) return null;

    const normalizedCode = featureCode.toUpperCase();
    const tenantFeature = tenantFeatures.find(
      tf => tf.feature_code && tf.feature_code.toUpperCase() === normalizedCode
    );
    return tenantFeature || null;
  },
};
